import React, { useEffect } from 'react';

const Blog = () => {
  useEffect(() => {
    // Redirect to the external blog
    window.location.href = 'https://abvig.org/blog/';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '60vh',
      background: '#1a0a03',
      color: '#E6D88A',
      fontFamily: 'Georgia, serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ color: '#D4AF37', marginBottom: '20px' }}>Redirecting to Blog...</h2>
        <p>Please wait while we redirect you to the ABVIG Blog.</p>
        <p style={{ marginTop: '20px', fontSize: '0.9rem' }}>
          If you are not redirected automatically,{' '}
          <a 
            href="https://abvig.org/blog/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#D4AF37', textDecoration: 'underline' }}
          >
            click here
          </a>
        </p>
      </div>
    </div>
  );
};

export default Blog;